import { FileProviderViewState } from 'owa-fileprovider-store';
import { sortFileProvidersViewState } from '../../utils/getAddedProviders';

export default function getDefaultFileProvider(fileProvidersViewState: FileProviderViewState[]) {
    const providers = sortFileProvidersViewState(fileProvidersViewState);
    if (fileProvidersViewState.length !== 0) {
        return providers[0];
    }
    return null;
}
